module.exports = __webpack_public_path__ + "images/close_icon_home0085884945f7d7e987ea9400f973d214.svg";